export enum LetterCommentReasonEnum {
  Forward = 'Forward',
  Reject = 'Reject'
}
